import Toast from 'awesome-toast-component';

export const displayToast = (msg) => {
    new Toast(msg, {
        position: 'top',
        theme: 'dark',
    });
};
